import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import LevelExpansion from './LevelExpansion';
import './MembershipOptions.css';
import { sendToSalesFlow } from '../../Utilities/Utils.js';
import ReactGA from 'react-ga';
import { setDigitalData } from '../../Utilities/Utils.js';

class DGRMembershipOptions extends Component {

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
        this.props.DGRStore.setValue( 'membership_flow' , true);
        setDigitalData( 'membership options', this.props.DGRStore.club_number );
    }

    constructor(props){
        super(props);
        this.productSelected = this.productSelected.bind(this)
    }

    productSelected(e){

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Membership Options',
            action: 'Product Selected',
            label: e.target.name
        });

        e.preventDefault();
        this.props.DGRStore.setProductID(e.target.name)
        //TODO - possibly bailout function if missing product_id and club_number 
        const { club_product_id, club_number } = this.props.DGRStore 
        const { lead_number, is_waiver_signed } = this.props.DGRStore.values;

        // No lead number means we don't have them signed in with a lead.
        if ( !lead_number ) {
            this.props.history.push('enter_pass');
        // Lead exists, but the waiver isn't signed yet.
        } else if ( !is_waiver_signed ) {
            this.props.history.push('sign_waiver');
        // Lead exists and waiver is signed. Check for product id.
        } else if ( club_product_id && club_number ) {
            sendToSalesFlow( club_product_id, club_number, this.props.DGRStore.values );
        // No product selected, so go home and reset.
        } else {
            this.props.DGRStore.clearValues();
            this.props.history.replace('');
        }
    }

    render(){
        const { levels } = this.props.DGRProductStore
        const expandSections  = levels.map((level,i)=>{
            var defaultExpanded = false
            if (i===0){
                defaultExpanded = true
            }
           return (
               <LevelExpansion selectFunction={this.productSelected} history={this.props.history} level={level}  key={i} defaultExpanded={defaultExpanded}/>
           );
        })
        return (
			<div>
                <div className="dgrTitleText">
                    <h1>Please Select a Membership to Continue</h1>
                </div>
            	{expandSections}
			</div>
        )
    }
}

DGRMembershipOptions = inject('DGRStore', 'DGRBackgroundStore','DGRProductStore')(observer(DGRMembershipOptions  ))     
export default DGRMembershipOptions ;



// WEBPACK FOOTER //
// ./src/components/DGR/MembershipOptions/MembershipOptions.js